import { render, staticRenderFns } from "./GroupNotes.vue?vue&type=template&id=5dc11ef4&"
import script from "./GroupNotes.vue?vue&type=script&lang=js&"
export * from "./GroupNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports